// Components==============
import Button from 'components/UI/Button/Button';
import EndpointDescription from 'components/UI/EndpointDescription/EndpointDescription';
import Token from 'components/UI/Token/Token';
import { usePermission } from 'hooks/usePermission';
import { EditableProcessEntity } from 'hooks/useProcessGroups';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext } from 'react';
import { ProjectProcessContext } from '../../ProjectProcess';
import Edit from './Edit';
import './EndPoint.module.scss';
// =========================

export default function EndPoint({
  token,
  process,
}: {
  token?: PhaseEntity | ActivityEntity | TrainingEntity;
  process?: EditableProcessEntity;
}) {
  const { isEditable, inModal, processGroups } = useContext(
    ProjectProcessContext
  );

  const { project, isMember } = useContext(ProjectDetailsContext);

  const isTeacher = usePermission(['Docent', 'super-admin']);

  const translate = useTranslate();

  const description = processGroups?.find(
    (group) =>
      group.id === process?.id && group.process_type === process.process_type
  )?.description as EndPointType;

  const teacherProject = !project?.members.find((m) => {
    const roles = m.user.roles.map((r) => r.name);

    const isStudent =
      roles.includes('Leerling') || roles.includes('Leerling Portfolio');

    return isStudent;
  });

  const isLocked = project?.locked_for_assessment === 1;

  const isExtern = usePermission(['Extern']);

  const showEndReflectionBtn =
    (!isTeacher || (isTeacher && !teacherProject)) &&
    !inModal &&
    !isLocked &&
    !isExtern;

  return (
    <div styleName="wrapper">
      <div styleName="top" style={{ pointerEvents: inModal ? 'none' : 'all' }}>
        <div styleName="token">
          {token && 'thumbnail' in token && <Token token={token} />}
        </div>
      </div>
      <div styleName="bottom_">
        {isEditable ? (
          <Edit description={description} process={process} />
        ) : (
          <>
            {!!description && (
              <EndpointDescription
                description={description}
                readOnly={!isMember || isLocked}
              />
            )}

            {showEndReflectionBtn && (
              <div styleName="end-reflection-btn-wrapper">
                <Button
                  color="grey"
                  to={`/groei/reflecteren/${project?.id}${
                    isTeacher ? '' : `/${process?.processId}`
                  }`}
                >
                  {isTeacher
                    ? // ? translate('general.terms.judge')
                      translate('general.terms.to-feedback')
                    : translate('general.terms.end-reflection')}
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
